import {useQuery, gql} from "@apollo/client";
import {useContext} from "react";
import {LocaleContext} from "../store/providers/LocaleProvider";
import {useLogger} from "./useLogger";

const QUERY = gql`
query getResortInspirationImages($hapimagResortId: Int!, $locale: String!){
    resortCollection(where: {hapimagResortId: $hapimagResortId}, locale: $locale){
        items{
            resortName,
            resortInspirationImagesCollection{
                items{
                    title,
                    url,
                }
            }
        }
    }

}`;

export const useResortInspirationImages = (hapimagResortId) => {
    const {localeUppercase} = useContext(LocaleContext)[0];
    const {logger} = useLogger();
    const { loading, error, data } = useQuery(QUERY, {
        variables: { hapimagResortId, locale: localeUppercase },
        errorPolicy: "all",
        skip: !hapimagResortId
    });

    const resortInspirationImages = data?.resortCollection?.items[0]?.resortInspirationImagesCollection?.items;

    if (error?.message) {
        logger(error?.message, "error", "useResortInspirationImages", error?.stack);
    }

    return {
        resortInspirationImages,
        loading,
        error
    };
};
